var app = angular.module('leonardo');

var FormColor = function(FilterService) {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      blur: '&ngBlur',
      focus: '&ngFocus',
      onSubmit: '&',
      label: '@',
      inline: '=',
      filter: '@',
      // type: '@',
      placeholder: '@',
      help: '@',
      clearText: '=',
      ngChange: '&',
      debounce:'=?'
    },
    templateUrl: 'views/templates/form/form-color.html',
    link: function (scope, element, attrs, ctrls) {
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];

      scope.debounce = !isNull(scope.debounce) ? scope.debounce : 0;
      scope.type = 'hex';
      scope.pattern = new RegExp('^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$');

      scope.$watch('value', function (value) {
        scope.ngModelCtrl.$setViewValue(value);
        if (scope.filter) {
          FilterService.setFilter(scope.filter, scope.value);
        }
      });

      scope.ngModelCtrl.$render = function () {
        scope.value = scope.ngModelCtrl.$viewValue;
        if (!scope.value && scope.filter) {
          scope.value = FilterService.getFilter(scope.filter);
        }
      };

      scope.clear = function() {
        if (scope.ngModelCtrl.$viewValue !== '') {
          scope.ngModelCtrl.$setViewValue('');
          scope.value = scope.ngModelCtrl.$viewValue;
          if (scope.filter) {
            FilterService.setFilter(scope.filter, scope.value);
          }
          scope.onSubmit();
        }
      };

      element.find('input').bind("keydown keypress", function (event) {
        if (event.keyCode === 13) {
          scope.$apply(function () {
            scope.onSubmit();
          });
          event.preventDefault();
        }
      });

    }
  };
};

app.directive('formColor', ['FilterService', FormColor]);